import { ReactNode } from 'react';

import classNames from 'classnames';

import useStyles from './ListItem.styles';

/**
 * Свойства компонента {@link ListItem}
 */
interface ListItemProps {
  /**
   * Дочерние элементы, которые будут отображены внутри элемента списка.
   */
  children: ReactNode;
}

/**
 * Компонент элемента списка.
 *
 * @public
 * @param children - Дочерние элементы, которые будут отображены внутри элемента списка.
 * @returns  Элемент списка с заданными дочерними элементами.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link ListItemProps}
 */
export const ListItem = ({ children }: ListItemProps) => {
  const { classes } = useStyles();

  return (
    <li className={classNames(classes.listItem, 'aqa_list_item')}>
      {children}
    </li>
  );
};
